import filter from "lodash/filter";
import isEmpty from "lodash/isEmpty";
import isNull from "lodash/isNull";
import Stripe from "stripe";
import { shallow } from "zustand/shallow";
import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

import useStripePaymentMethodStore, {
  STRIPE_PAYMENT_METHODS_QUERY_KEYS,
} from "../store";
import { getUserPaymentMethods } from "../../../api/stripe";
import { bugNotif } from "../../../api/bugsnag";
import { getErrorMsg } from "../../../../Common/utils/common";
import { useWebUserStore } from "../../../CommonStores/user/users";

const usePaymentMethodsProvider = () => {
  const { setPaymentMethods } = useStripePaymentMethodStore(
    (state) => state,
    shallow
  );
  const [user] = useWebUserStore((state) => [state.user]);

  const { data: paymentMethodsResult, error: paymentMethodsError } = useQuery({
    queryKey: [STRIPE_PAYMENT_METHODS_QUERY_KEYS.paymentMethods, user],
    queryFn: async () => {
      if (
        user === undefined ||
        isNull(user) ||
        user.stripeId === undefined ||
        isEmpty(user.stripeId)
      ) {
        return undefined;
      }
      return await getUserPaymentMethods(user.stripeId);
    },
    refetchOnWindowFocus: true,
  });

  useEffect(() => {
    if (!isNull(paymentMethodsError)) {
      bugNotif(
        STRIPE_PAYMENT_METHODS_QUERY_KEYS.paymentMethods,
        getErrorMsg(paymentMethodsError).rawErrorMsg
      );
    }
  }, [paymentMethodsError]);

  useEffect(() => {
    if (paymentMethodsResult !== undefined) {
      setPaymentMethods(
        filter(
          paymentMethodsResult.data.result.data,
          (data: Stripe.PaymentMethod) => data.card !== undefined
        )
      );
    }
  }, [paymentMethodsResult]);
};

export default usePaymentMethodsProvider;
